import { render } from "./PlanOrgenIframe.vue?vue&type=template&id=dad4015c&ts=true"
import script from "./PlanOrgenIframe.ts?vue&type=script&lang=ts&external"
export * from "./PlanOrgenIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__